import React from 'react'

export default function FlutterIcon() {
   return (
      <svg
         width="301"
         height="484"
         className="w-100"
         viewBox="0 0 301 484"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_5116_196944)">
            <path
               d="M57.9833 243.267L0.804688 186.088L186.463 0.445312H300.805M300.805 171.756H186.463L143.631 214.587L200.81 271.766"
               fill="#F1ECDC"
               fillOpacity="0.8"
            />
            <path
               d="M143.631 328.929L186.462 371.761H300.804L200.809 271.766"
               fill="#F1ECDC"
            />
            <path
               d="M86.5879 271.795L143.676 214.691L200.765 271.78L143.676 328.883L86.5879 271.795Z"
               fill="#F1ECDC"
            />
            <path
               d="M143.676 328.885L200.764 271.797L208.733 279.766L151.645 336.854L143.676 328.885Z"
               fill="url(#paint0_linear_5116_196944)"
            />
            <path
               d="M143.631 328.929L228.468 299.619L200.809 271.75"
               fill="url(#paint1_linear_5116_196944)"
            />
         </g>
         <path
            d="M79.7958 462.762H76.3878V430.602H100.484V433.722H79.7958V446.01H99.7638V449.082H79.7958V462.762ZM108.436 462.762H105.028V430.602H108.436V462.762ZM124.105 463.242C117.337 463.242 114.025 458.538 114.025 452.922V439.05H117.433V452.394C117.433 457.338 119.833 460.17 125.305 460.17C131.113 460.17 134.137 456.666 134.137 450.57V439.05H137.545V462.762H134.473V455.37H134.233C133.417 459.402 130.009 463.242 124.105 463.242ZM157.822 462.762H152.686C147.982 462.762 144.958 460.794 144.958 455.226V441.978H140.734V439.05H144.958V433.386H148.414V439.05H157.822V441.978H148.414V455.418C148.414 458.73 150.046 459.642 153.502 459.642H157.822V462.762ZM176.104 462.762H170.968C166.264 462.762 163.24 460.794 163.24 455.226V441.978H159.016V439.05H163.24V433.386H166.696V439.05H176.104V441.978H166.696V455.418C166.696 458.73 168.328 459.642 171.784 459.642H176.104V462.762ZM191.121 463.242C183.489 463.242 178.641 458.442 178.641 450.906C178.641 443.706 183.441 438.57 191.073 438.57C198.033 438.57 202.977 442.602 202.977 449.658C202.977 450.522 202.881 451.242 202.737 451.866H181.857C182.049 457.194 184.785 460.41 191.073 460.41C196.641 460.41 199.233 458.346 199.233 454.89V454.554H202.641V454.89C202.641 459.834 197.745 463.242 191.121 463.242ZM191.025 441.402C184.881 441.402 182.097 444.57 181.857 449.754H199.761C199.761 449.514 199.761 449.274 199.761 449.034C199.761 444.042 196.593 441.402 191.025 441.402ZM210.905 462.762H207.497V439.05H210.569V445.53H210.809C211.529 441.738 214.217 438.57 219.161 438.57C224.633 438.57 227.033 442.602 227.033 447.018V449.37H223.625V447.546C223.625 443.514 221.945 441.546 217.817 441.546C213.017 441.546 210.905 444.57 210.905 449.898V462.762Z"
            fill="#F1ECDC"
         />
         <defs>
            <lineargradient
               id="paint0_linear_5116_196944"
               x1="172.231"
               y1="300.331"
               x2="180.2"
               y2="308.3"
               gradientUnits="userSpaceOnUse"
            >
               <stop offset="0.2" stopOpacity="0.15" />
               <stop offset="0.85" stopColor="#616161" stopOpacity="0.01" />
            </lineargradient>
            <lineargradient
               id="paint1_linear_5116_196944"
               x1="143.651"
               y1="300.341"
               x2="228.487"
               y2="300.341"
               gradientUnits="userSpaceOnUse"
            >
               <stop offset="0.2" stopColor="#F1ECDC" stopOpacity="0.55" />
               <stop offset="0.85" stopColor="#F1ECDC" stopOpacity="0.01" />
            </lineargradient>
            <clippath id="clip0_5116_196944">
               <rect
                  width="300"
                  height="371.316"
                  fill="white"
                  transform="translate(0.804688 0.445312)"
               />
            </clippath>
         </defs>
      </svg>
   )
}
